import type { Assignment, Activity } from "../api/assignments/Assignments.domain";
import type { Rules } from "../api/rules/Rules.domain";
import { getActivityPrefillValue, defaultActivityPrefillConfig } from "./activityPrefill";

/**
 * Returns suggested values per activity index for prefill (IMEI, features, etc.).
 */
export function getSuggestedValuesByIndex(
  assignment: Assignment,
  localActivities: Activity[],
  rules: Rules,
): Record<number, Record<string, string>> {
  const map: Record<number, Record<string, string>> = {};
  const assignmentWithLocal = { ...assignment, activities: localActivities };

  localActivities.forEach((activity, idx) => {
    const rule = rules.rules.find((r) => r.activityTypeCode === activity.activityType?.code);
    const returnStatuses = rule?.possibleReturns ?? [];
    const selectedPossibleReturn =
      returnStatuses.find((s) => s.stepCode === activity.responseDetail?.stepCode) ?? null;
    const specificFields = selectedPossibleReturn?.specificFields ?? [];
    const suggestedValues: Record<string, string> = {};
    for (const field of specificFields) {
      const v = getActivityPrefillValue(
        assignmentWithLocal,
        field.code,
        defaultActivityPrefillConfig,
      );
      if (v) suggestedValues[field.code] = v;
    }
    map[idx] = suggestedValues;
  });

  return map;
}
